// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as UseApi$Showside from "../hook/UseApi.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as Dropdown$Showside from "./Dropdown.bs.js";
import * as UseSorts$Showside from "../hook/UseSorts.bs.js";
import * as IconButton$Showside from "./IconButton.bs.js";
import * as FiltersSection$Showside from "./FiltersSection.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ProductSortOrder2$Showside from "../utils/ProductSortOrder2.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function ListPageSort$SortDropDown(Props) {
  var appliedSort = Props.appliedSort;
  var availableSortsOpt = Props.availableSorts;
  var onOpenOpt = Props.onOpen;
  var onCloseOpt = Props.onClose;
  var onChangeSort = Props.onChangeSort;
  var isOpenOpt = Props.isOpen;
  var availableSorts = availableSortsOpt !== undefined ? availableSortsOpt : [];
  var onOpen = onOpenOpt !== undefined ? onOpenOpt : function (param) {};
  var onClose = onCloseOpt !== undefined ? onCloseOpt : function (param) {};
  var isOpen = isOpenOpt !== undefined ? isOpenOpt : false;
  var match = ViewportContext$Showside.use(undefined);
  var estimatedDropdownHeight = Math.min(12 + Math.imul(availableSorts.length, 35) | 0, 350);
  var options = Belt_Array.mapWithIndex(availableSorts, function (index, availableSort) {
    var title = availableSort[0];
    return {
      id: title,
      index: index,
      facet: "",
      label: title,
      swatch: undefined,
      value: appliedSort === availableSort[1],
      count: 0,
      disabled: false
    };
  });
  var section = {
    label: "Sort by",
    id: "sorts",
    options: options,
    style: /* Radio */5,
    visible: true
  };
  var getSortOptionFromSelections = function (selections) {
    return Belt_Option.map(Belt_Array.getBy(availableSorts, function (param) {
      return param[0] === Belt_Option.map(Belt_Array.get(Belt_Array.keep(selections, function (f) {
        return f.value;
      }), 0), function (f) {
        return f.label;
      });
    }), function (param) {
      return param[1];
    });
  };
  return React.createElement(Dropdown$Showside.make, {
    isOpen: isOpen,
    onOpen: onOpen,
    onClose: onClose,
    children: React.createElement(FiltersSection$Showside.make, {
      section: section,
      showLabel: false,
      canCollapse: false,
      border: false,
      onChange: function (selections) {
        Curry._1(onChangeSort, getSortOptionFromSelections(selections));
      },
      autoFocus: isOpen,
      large: match.isMobile,
      className: CSS$Showside.prefix("w-full relative"),
      rtl: true,
      sectionIdPrefix: "sorts"
    }),
    className: CSS$Showside.prefix("mt-2"),
    label: "Sort",
    height: estimatedDropdownHeight
  });
}
ListPageSort$SortDropDown.displayName = "ListPageSort.SortDropDown";
var SortDropDown = {
  make: ListPageSort$SortDropDown
};
function sortToTuple(sort) {
  return [ProductSortOrder2$Showside.humanizeSort(sort), sort];
}
function ListPageSort(Props) {
  var categoryId = Props.categoryId;
  var connection = Props.connection;
  var appliedSort = Props.appliedSort;
  var appliedFilters = Props.appliedFilters;
  var match = EntrypointContext$Showside.use(undefined);
  var trackEvent = match.trackEvent;
  var match$1 = ConfigurationProvider$Showside.use(undefined).config;
  var account = match$1.transitiveAccount;
  var match$2 = React.useState(function () {
    return false;
  });
  var _setIsDropdownOpen = match$2[1];
  var isDropdownOpen = match$2[0];
  var setIsDropdownOpen = function (callback) {
    Curry._1(_setIsDropdownOpen, function (isDropdownOpen) {
      var result = Curry._1(callback, isDropdownOpen);
      if (result) {
        Curry.app(trackEvent, ["sort expanded", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      }
      return result;
    });
  };
  var defaultFilters = Belt_Option.flatMap(connection, function (connection) {
    return Category$Showside.ExternalConnection.getFilterBy(connection, account);
  });
  var match$3 = UseApi$Showside.useCategoryProducts(undefined, match$1.transitiveStoreId, categoryId, connection, match$1.settings.hideOutOfStock, appliedFilters, defaultFilters, undefined, appliedSort, true, match.smartnavApiHost, undefined, match.market, undefined);
  var swr = match$3.swr;
  var availableSorts = Belt_Option.flatMap(Belt_Option.flatMap(swr.data, function (data) {
    return Belt_Array.get(data, 0);
  }), function (page) {
    return page.availableSorts;
  });
  var categoryDefaultSort = Belt_Option.flatMap(Belt_Option.flatMap(swr.data, function (data) {
    return Belt_Array.get(data, 0);
  }), function (page) {
    return page.defaultSortOrder;
  });
  var match$4 = UseSorts$Showside.useSorts(appliedSort, categoryDefaultSort, availableSorts, connection);
  var appliedSort$1 = match$4[0];
  appliedSort$1 !== undefined ? appliedSort$1 !== 0 || categoryDefaultSort === undefined ? appliedSort$1 : categoryDefaultSort !== 0 ? categoryDefaultSort : undefined : categoryDefaultSort !== undefined && categoryDefaultSort !== 0 ? categoryDefaultSort : undefined;
  var label = "Sort";
  var dropdown = React.createElement(ListPageSort$SortDropDown, {
    appliedSort: appliedSort$1,
    availableSorts: match$4[1],
    onOpen: function (param) {
      setIsDropdownOpen(function (param) {
        return true;
      });
    },
    onClose: function (param) {
      setIsDropdownOpen(function (param) {
        return false;
      });
    },
    onChangeSort: match.onChangeSort,
    isOpen: isDropdownOpen
  });
  return React.createElement(React.Fragment, undefined, React.createElement(IconButton$Showside.make, {
    onMouseDown: function (param) {
      setIsDropdownOpen(function (param) {
        return !isDropdownOpen;
      });
    },
    clear: true,
    iconSize: /* Small */3,
    labelSize: /* Small */3,
    icon: React.createElement(Unicons$Showside.UilAngleLeftB.make, {
      size: /* Px */{
        _0: 20
      }
    }),
    iconFirst: false,
    noMargin: true,
    label: label,
    dataTestId: "plp-sort-button",
    dataActive: isDropdownOpen,
    iconClassName: CSS$Showside.prefix(Cn.make([isDropdownOpen ? "rotate-90" : "-rotate-90", "ml-2 transform-gpu w-7 h-7"])),
    labelClassName: CSS$Showside.prefix("font-medium")
  }), dropdown);
}
ListPageSort.displayName = "ListPageSort";
var make = ListPageSort;
export { SortDropDown, sortToTuple, make };
/* react Not a pure module */